import { getWindow } from "@/shared/getWindow";
import { useCallback } from "react";

export function useNavigation() {
  const navigate = useCallback(
    (path: string, options?: { replace?: boolean }) => {
      if (options?.replace) {
        getWindow()?.history.replaceState(null, "", path);
      } else {
        getWindow()?.history.pushState(null, "", path);
      }

      getWindow()?.dispatchEvent(new PopStateEvent("popstate"));
    },
    [],
  );

  const replace = useCallback(
    (path: string) => {
      navigate(path, { replace: true });
    },
    [navigate],
  );

  return { navigate, replace };
}

export function useSearchParams() {
  const searchParams = new URLSearchParams(getWindow()?.location.search);
  return searchParams;
}
